export default __webpack_public_path__ + "7b1c19dfb46360d0e40debca57339857.gif";